import { render, staticRenderFns } from "./DeviceControlPanel.vue?vue&type=template&id=06a05f88&scoped=true"
import script from "./DeviceControlPanel.vue?vue&type=script&lang=js"
export * from "./DeviceControlPanel.vue?vue&type=script&lang=js"
import style0 from "./DeviceControlPanel.vue?vue&type=style&index=0&id=06a05f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a05f88",
  null
  
)

export default component.exports